import api from "@/lib/api";

// ProgereReleaseService — accès au système de versions (module CRM).
export const ProgereReleaseService = {
  moduleInfo: () => api.get("/releases/module").then((r) => r.data),
  current: () => api.get("/releases/current").then((r) => r.data),
  history: () => api.get("/releases").then((r) => r.data),
  unseen: () => api.get("/releases/unseen").then((r) => r.data.release),
  markSeen: (id) => api.post(`/releases/${id}/seen`).then((r) => r.data),
  acknowledge: (id) => api.post(`/releases/${id}/acknowledge`).then((r) => r.data),

  // Administration (admin plateforme)
  adminList: () => api.get("/admin/releases").then((r) => r.data),
  nextVersion: (release_type) => api.get(`/admin/releases/next-version?release_type=${release_type}`).then((r) => r.data),
  create: (body) => api.post("/admin/releases", body).then((r) => r.data),
  update: (id, body) => api.put(`/admin/releases/${id}`, body).then((r) => r.data),
  publish: (id) => api.post(`/admin/releases/${id}/publish`).then((r) => r.data),
  remove: (id) => api.delete(`/admin/releases/${id}`).then((r) => r.data),
  archive: (id) => api.post(`/admin/releases/${id}/archive`).then((r) => r.data),
};
